var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
const FieldValidationErrors = (props) => {
    if (props.fieldValidationErrorsComponent) {
        const CustomError = props.fieldValidationErrorsComponent;
        // strip the errors component from the custom component props
        // (prevents infinite loop rendering if someone reuses this component as a custom error component)
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        const { fieldValidationErrorsComponent } = props, errorsComponentProps = __rest(props, ["fieldValidationErrorsComponent"]);
        return React.createElement(CustomError, Object.assign({}, errorsComponentProps));
    }
    const { errors } = props;
    if (!errors || errors.length === 0) {
        return null;
    }
    return (React.createElement("div", { className: "invalid" }, errors.map((error, index) => (React.createElement("p", { key: index }, error)))));
};
export { FieldValidationErrors };
